module.exports = __webpack_public_path__ + "static/iss-2084c5c5085ddaa68369944b7e444f50.mp4";